export function formatInteger(value: number, locale = 'no'): string {
  if (!Number.isFinite(value)) return String(value)

  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0,
  }).format(value)

  if (locale === 'no') {
    return formatted.replace(/[\s\u00a0\u202f]/g, '.')
  }

  return formatted
}
